import React from "react";
import { Table, Spin } from "antd";
import { ITaskOrder, TaskOrderStatus } from "../../types/taskOrder.type";
import dayjs from "dayjs";
import { useAuth } from "../../contexts/auth.context";
import { UserRole } from "../../types/user.type";

interface TaskOrdersRes {
  data: ITaskOrder[] | null;
  loading: boolean;
}

export default function TaskOrders({ data, loading }: TaskOrdersRes) {
  const { authState } = useAuth();
  let height = "300px";

  if (
    authState.user?.role === UserRole.Foreman ||
    authState.user?.role === UserRole.SalesDept
  ) {
    height = "660px";
  }

  if (loading) {
    return <Spin size="large" />;
  }

  if (!data) {
    return <div>No data available</div>;
  }

  const columns = [
    {
      title: "Название",
      dataIndex: "produceName",
      key: "produceName",
    },
    {
      title: "Выдано",
      dataIndex: "given",
      key: "given",
    },
    {
      title: "Дата загатовки",
      dataIndex: "tanningDate",
      key: "tanningDate",
    },
    {
      title: "Дата выдачи",
      dataIndex: "givenDate",
      key: "givenDate",
    },
    {
      title: "Валюта",
      dataIndex: "currency",
      key: "currency",
    },
    {
      title: "Кол-во",
      dataIndex: "total",
      key: "total",
    },
    {
      title: "Сумма",
      dataIndex: "totalCost",
      key: "totalCost",
    },
    {
      title: "Имя клиента",
      dataIndex: "clientName",
      key: "clientName",
    },
    {
      title: "Статус",
      dataIndex: "status",
      key: "status",
    },
  ];

  const rowClassName = (record: ITaskOrder) => {
    if (record.status === TaskOrderStatus.Completed) {
      return "row-green";
    }

    if (record.status === TaskOrderStatus.Rejected) {
      return "row-red";
    }

    const today = dayjs().startOf("day");

    const givenDate = dayjs(record.givenDate, "DD.MM.YYYY");

    if (givenDate.isBefore(today)) {
      return "row-yellow";
    }

    return "";
  };

  return (
    <div style={{ padding: "20px" }}>
      <h2>Задачи-Заказы</h2>

      <div style={{ marginTop: "20px", height, overflowY: "auto" }}>
        <Table
          dataSource={data}
          columns={columns}
          rowKey={(record) => record._id}
          pagination={false}
          scroll={{ y: height }}
          style={{ height }}
          rowClassName={rowClassName}
        />
      </div>
    </div>
  );
}
